import cx from 'classnames';
import Box, { BoxStyleProps } from '../Box';

import styles from './FadeBorder.module.css';

interface FadeBorderProps extends BoxStyleProps {
  className?: string;
}

export default function FadeBorder({
  className,
  ...otherProps
}: FadeBorderProps): JSX.Element {
  return (
    <Box as="div" className={cx(styles['base'], className)} {...otherProps} />
  );
}
